import { StatCard } from 'components/stat-card';
import { useAtomValue } from 'jotai';
import { searchAtom } from '../atoms';
import { Charts } from 'components/charts';
import style from './interpretation-stats.module.scss';
import { CHART_TYPES, ChartTypes } from './types';
import { Dropdown, Layer } from '@carbon/react';
import { useState } from 'react';
import { format0 } from '../../../utils/number';

const InterpretationStats = () => {
  const searchResult = useAtomValue(searchAtom);
  const chartValues = Object.values(CHART_TYPES);
  const [selectedChart, setSelectedChart] = useState<ChartTypes>(
    CHART_TYPES.bookType
  );
  const {
    interpretationCount,
    totalTransactions,
    totalLeaseTypes,
    totalBookTypes,
    totalDocumentTypes,
    totalReviewTypes,
    totalCurativeTypes,
  } = searchResult?.data?.aggregations || {};
  return (
    <section className={style.sectionContainer}>
      <div className={style.statsContainer}>
        <StatCard
          title="Total Interpretations"
          value={format0(interpretationCount, '0')}
        />
        <StatCard
          title="Total Transactions"
          value={format0(totalTransactions, '0')}
        />
        <StatCard
          title="Total Leases"
          value={format0(totalLeaseTypes?.['mineral lease transaction'], '0')}
        />
      </div>
      <div className={style.graphContainer}>
        <div className={style.dropDownContainer}>
          <Layer>
            <Dropdown
              label="Charts"
              titleText="Charts"
              onChange={({ selectedItem }: { selectedItem: ChartTypes }) => {
                if (selectedItem) setSelectedChart(selectedItem);
              }}
              itemToString={(item: string) => item}
              id="document-type"
              items={chartValues}
              type="default"
              selectedItem={selectedChart}
            />
          </Layer>
        </div>
        {selectedChart === CHART_TYPES.bookType && (
          <Charts
            data={totalBookTypes}
            titleText={'Book Type'}
            xAxisText={'Book Type'}
            yAxisText={'Total'}
            seriesName={'Total'}
            dataLabelsEnabled={false}
          />
        )}
        {selectedChart === CHART_TYPES.documentType && (
          <Charts
            data={totalDocumentTypes}
            titleText={'Document Type'}
            xAxisText={'Document Type'}
            yAxisText={'Total'}
            seriesName={'Total'}
            dataLabelsEnabled={false}
          />
        )}
        {selectedChart === CHART_TYPES.reviewed && (
          <Charts
            data={totalReviewTypes}
            xAxisText={'Review Type'}
            yAxisText={'Total'}
            titleText={'Review Type'}
            seriesName={'Total'}
            dataLabelsEnabled={false}
          />
        )}
        {selectedChart === CHART_TYPES.curative && (
          <Charts
            data={totalCurativeTypes}
            xAxisText={'Curative Type'}
            yAxisText={'Total'}
            titleText={'Curative Type'}
            seriesName={'Total'}
            dataLabelsEnabled={false}
          />
        )}
      </div>
    </section>
  );
};

export { InterpretationStats };
